<template>
    <div class="businessCenter">
        <div class="banner_top">
            <img :src="this.sylbAddress" alt="" />
            <div class="content">
                <div>{{ headerMenus }}</div>
                <div>{{ serviceHotline }}：010-81215833</div>
            </div>
        </div>
        <div class="banner_bottom" v-for="(item, index) in businessDHTreeList" :key="item.menuId" :index="index.toString()">
            <div class="product_head">
                <div class="title">{{ item.guideZw }}</div>
            </div>
            <div class="product_list">
                <div class="product_list_item" v-for="(ite, idx) in item.gList" :key="ite.menuId" :index="idx.toString()">
                    <div class="left">
                        <div class="title">{{ ite.guideZw }}</div>
                        <div class="btn" @click="toDetails(index ,idx)">{{ detailsBtn }}</div>
                    </div>
                    <div class="right">
                        <img :src="ite.backup1" alt="">
                    </div>
                </div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
import vFooter from '../common/footer.vue';
import { gwGetMenuList, gwGetSYLBList, gwGetBusinessDHTreeList } from '@/api/index';
export default {
    name: 'businessCenter',
    components: {
        vFooter
    },
    data() {
        return {
            isShowTooltip:false,
            languageType: '1',
            sylbAddress: '',
            headerMenus: '',
            serviceHotline: '',
            detailsBtn: '',
            businessDHTreeList: [],
            selected: null,
            htmlText: ''
        };
    },
    watch: {
        $route(to, from){}
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
            this.toDetailsBtn();
        }
        this.toDetailsBtn();
        this.gwGetMenuList();
        this.gwGetSYLBList();
        this.gwGetBusinessDHTreeList();
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.toDetailsBtn();
            this.gwGetMenuList();
            this.gwGetSYLBList();
            this.gwGetBusinessDHTreeList();
        });
    },
    methods: {
        toDetailsBtn() {
            if (this.languageType == 2) {
                this.detailsBtn = 'View details'
            } else if (this.languageType == 3) {
                this.detailsBtn = 'Проверьте детали.'
            } else {
                this.detailsBtn = '查看详情'
            }
        },
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then((res) => {
                this.headerMenus = res.obj.menuList[1].guideZw,
                this.serviceHotline = res.obj.serviceHotline;
            });
        },
        gwGetSYLBList() {
            let params = {
                language: this.languageType,
                type: '2'
            };
            gwGetSYLBList(params).then(res => {
                this.sylbAddress = res.obj[0].sylbAddress
            });
        },
        gwGetBusinessDHTreeList() {
            let params = {
                language: this.languageType
            };
            gwGetBusinessDHTreeList(params).then(res => {
                // console.log('查询业务导航tree', res.obj,this.indexs);
                this.businessDHTreeList = res.obj;
            });
        },
        toDetails(index, idx) {
            this.$router.push({
                path: '/operationDetails',
                query: { index: index, idx: idx } // 大类别index，小类别idx
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
.businessCenter {
    background-color: #f7f7f7;
    font-family: Source Han Sans;
    .banner_top {
        width: 100%;
        height: 4.95rem;
        margin: auto;
        // margin-bottom: -32px;
        overflow: hidden;
        position: relative;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
        .content {
            color: #fff;
            position: absolute;
            top: 1.875rem; /* 距离顶部10像素 */
            left: 2.75rem; /* 距离左侧10像素 */
            padding: .125rem;
        }
        .content > div:nth-child(1) {
            font-size: .75rem;
            font-weight: 500;
            margin-bottom: .3rem;
        }
        .content > div:nth-child(2) {
            font-size: .35rem;
            font-weight: 400;
        }
    }
    .banner_bottom {
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        margin: 0 3.25rem 1.25rem;
    }
    .product_head {
        margin: .875rem 0rem;
        width: 100%;
        text-align: left;
        .title {
            margin-bottom: .2rem;
            font-size: .5rem;
            font-weight: 600;
            line-height: .5rem;
            color: #023e7a;
        }
    }
    .product_list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;
        width: 100%;
        // display: flex;
        // justify-content: space-between;
        // margin-right: 20px;
        .product_list_item {
            display: flex;
            justify-content: space-between;
            // align-items: center;
            width: 8.5rem;
            height: 4.0625rem;
            background: #fff;
            border-radius: .125rem;
            box-shadow: .025rem .025rem .0625rem .0125rem rgba(0, 0, 0, 0.1);
            .left {
                padding: .375rem .3rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                color: #333;
                .title {
                    font-size: .3rem;
                    font-weight: 500;
                }
                .btn {
                    max-width: 1.65rem;
                    text-align: center;
                    font-size: .175rem;
                    line-height: .25rem;
                    padding: .0625rem .3rem;
                    font-weight: 350;
                    border: .0125rem solid #002769;
                    border-radius: .625rem;
                }
                .btn:hover {
                    color: #fff;
                    background: #023e7a;
                    cursor: pointer;
                }
            }
            .right {
                overflow: hidden;
                width: 4.45rem;
                height: 4.0625rem;
                display: flex;
                // align-items: center;
                img {
                    object-fit: cover;
                    width: 100%;
                    height: auto;
                    border-radius: 0 .125rem .125rem 0;
                }
            }
        }
    }
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard syntax */
}
</style>
